<template>
    <div v-wechat-title="title" class="padding10">
        <h1>
            {{ today }}
            <el-button @click="showScanInRecoveryBed" v-has-permission="inRecoveryScanPermission">扫码入室</el-button>
            <div :style="{ float: `right`, 'margin-right': `${collapse == 0?`13`:`1`}%`}">
                <el-button type="primary" size="mini" v-has-permission="inRecoveryPermission" @click="showInRecoveryPatient">创建复苏单</el-button>
                 <!-- v-if="isDesktop" -->
                <el-button @click="updateScreen" v-has-permission="showscreenbtnPermission">复苏屏设置</el-button>
                <i style="cursor: pointer" :class="collapse == 1 ? 'el-icon-s-fold' : 'el-icon-s-unfold'" @click="triggerCollapse()"></i>
            </div>
        </h1>
        <el-row>
            <el-col :span="4" class="align-left">
                <div class="recovery-list-header">
                    <span>{{ recoveryApplicationInterval > 0? "复苏申请列表":"复苏患者"}}({{ unRecoveries.length }})</span><span class="cus-button is-circle" @click="loadAll" title="刷新"><span class="el-icon-refresh"></span></span>
                </div>
                <el-scrollbar :style="{ height: this.screenHeight - 210 + 'px' }" v-if="unRecoveries.length > 0">
                    <draggable
                        tag="ul"
                        :sort="false"
                        :options="{
                            group: { name: 'unrecovries', put: false, pull: 'clone' },
                            animation: 150,
                            ghostClass: 'sortable-ghost',
                            chosenClass: 'chosenClass',
                            scroll: true,
                            scrollSensitivity: 200
                        }"
                        v-model="unRecoveries"
                    >
                        <li v-for="v in unRecoveries" :key="v.id">
                            <div v-if="recoveryApplicationInterval && recoveryApplicationInterval > 0"
                                style=" cursor: pointer; padding: 5px 0px 5px 0px"
                                >
                                <el-row style="border-bottom: 0.5px solid lightgray; cursor: pointer; padding: 5px 0px 5px 0px">
                                    <el-col :span="1" >
                                                <div
                                                    class="surgery-status-tag"
                                                    :style="{ height: '200px' }"
                                                    :class="
                                                     v.enum_message_status == 1 ? 'bg-blue'
                                                   : v.enum_message_status == 3 ? 'bg-primary'
                                                   : v.enum_message_status == 4?'bg-warning'
                                                   : ''
                                                    "
                                                >
                                                </div>
                                            </el-col>
                                     <el-col :span="21" class="padding5 padding-none-v align-left" style="padding-bottom: 5px">
                                        <div class="ellipsis"><b>患者信息{{ v.patient_name }}
                                            <span style="font-size: 14px">{{ `(${v.sex || '--'}/${v.age || '--'}/${v.visit_no || '--'})` }}</span></b>
                                        </div>
                                <div class="ellipsis font-size12">麻醉医师：{{ v.anes_doctor }}</div>
                                <div class="ellipsis font-size12">手术间：{{ v.dic_operating_room }}</div>
                                <div class="ellipsis font-size12">手术名称：{{ v.surgeries }}</div>
                                <div class="ellipsis font-size12">手术状态：{{ v.surgery_status }}</div>
                                <div class="ellipsis font-size12">身高：{{ v.height }}</div>
                                <div class="ellipsis font-size12">体重：{{ v.weight }}</div>
                                <div class="ellipsis font-size12 fontcolor-warning">传染病：{{ v.infectious }}</div>
                                <div class="ellipsis font-size12">复苏申请时间：{{ $moment(v.plan_time).format(`YYYY-MM-DD HH:mm`) }}</div>
                                <div class="ellipsis font-size12"  >复苏申请状态：<span :class="
                                                     v.enum_message_status == 1 ? 'fontcolor-blue'
                                                   : v.enum_message_status == 3 ? 'fontcolor-primary'
                                                   : v.enum_message_status == 4?'fontcolor-warning'
                                                   : ''">{{ v.enum_message_status == 1?'新申请':(v.enum_message_status == 2?'已撤回':(v.enum_message_status == 3?'同意申请':'等待'))
                                    }}</span></div>
                                <div v-if="v.enum_message_status != 2" style="display: flex;justify-content: flex-end;">
                                    <el-button type="primary" size="small" @click="sendMessageToOperRoom(v.id)">{{v.enum_message_status == 3?'已同意':'同意接收'}}</el-button>
                                    <el-button type="primary" size="small" @click="showWaitToOperRoom(v.id)">等待</el-button>
                                </div>
                                     </el-col>
                                </el-row>
                            </div>
                            <div v-else
                                >
                                <div>
                                    <b>姓名：{{ v.patient_name }}
                                        <span style="font-size: 14px">
                                            {{ `(${v.sex || '--'}/${v.age || '--'}/${v.visit_no || '--'})` }}
                                        </span></b>
                                </div>
                                <div>麻醉医师：{{ v.anes_doctor }}</div>
                                <div>手术间：{{ v.dic_operating_room }}</div>
                                <div>手术名称：{{ v.surgeries }}</div>
                                <div>申请时间：{{ $moment(v.plan_time).format(`YYYY-MM-DD HH:mm:ss`) }}</div>
                            </div>
                        </li>
                    </draggable>
                </el-scrollbar>
                <p v-else style="color: lightgray">暂无</p>
            </el-col>
            <el-col :span="collapse==0?17:20">
                <el-scrollbar :style="{ height: this.screenHeight - 180 + 'px' }">
                    <draggable tag="el-row" v-model="recoveryBeds" v-if="recoveryBeds.length > 0" v-bind="{ group: { name: 'card', pull: false, put: false }, animation: 150 }" @change="exchangeBed">
                        <el-col :xl="defaultRecordBedCount" :md="defaultRecordBedCount" v-for="p in recoveryBeds" :key="p.location_id" class="padding5">
                            <el-card :body-style="{ padding: '5px' }">
                                <div class="card-header">
                                    <el-row class="height40 padding10 padding-none-v" type="flex" align="middle">
                                        <el-col :span="16" style="line-height: 40px">
                                            <b>{{ p.location }}</b>
                                            <span v-if="p.visit" style="float: right" :title="p.visit.patient_name">
                                                <b class="fg-primary">{{ splitName(p.visit.patient_name) }}</b>
                                                {{ p.visit && `${p.visit.sex || '--'}/${p.visit.age || '--岁'}` }}
                                                <span class="circle fg-red borderd" v-if="p.visit.is_reoperation">再</span>&nbsp;&nbsp;
                                            </span>
                                            <template v-else>(空)</template>
                                        </el-col>
                                    <el-col :span="2" v-has-permission="lockBedPermission" class="align-right" :title="p.is_lock?`${p.lock_worker_name} 于 ${p.lock_time && $moment(p.lock_time).format(`YYYY-MM-DD HH:mm:ss`)|| ``}锁定`:`锁定床位`">
                                        <span :class="{ 'el-icon-lock': p.is_lock,'el-icon-unlock': !p.is_lock,}" class="cus-button is-circle" @click="lockBed(p)"></span>
                                    </el-col>
                                        <el-col :span="2" class="align-right" title="查看苏醒单">
                                            <span v-if="p.visit" class="cus-button is-circle el-icon-document" @click="loadRevDoc(p.visit.id)"></span>
                                        </el-col>
                                        <el-col :span="2" class="align-right" title="更换床位">
                                            <span v-if="p.visit" class="cus-button is-circle el-icon-edit-outline" @click="btnchangeBeds(p)"></span>
                                        </el-col>
                                        <el-col
                                            :span="2"
                                            class="align-right"
                                            title="取消复苏"
                                            v-if="permissions && permissions.findIndex(item => item.permission === 'surgery_list:cancelRecovery') != -1"
                                        >
                                            <span v-if="p.visit" class="cus-button is-circle" @click="recoveryBedReply(p)">
                                                <font-awesome-icon :icon="['fas', 'reply']"></font-awesome-icon>
                                            </span>
                                        </el-col>
                                        <el-col :span="2" class="align-right" title="出苏醒室">
                                            <span v-if="p.visit" class="cus-button is-circle" @click="recoveryBedOut(p)">
                                                <font-awesome-icon :icon="['fas', 'sign-out-alt']"></font-awesome-icon>
                                            </span>
                                        </el-col>
                                    </el-row>
                                </div>
                                <div class="card-content" @dblclick="loadRevDoc(p.visit.id)">
                                    <el-scrollbar wrap-class="scrollbar-wrapper-y" style="height: 100%" v-if="p && p.visit">
                                        <el-row>
                                            <el-col :span="18" class="padding10">
                                                <div style="min-height: 50px; border-bottom: dashed 0.5px lightgrey" v-show="showInfo(1) || showInfo(2) || showInfo(3)">
                                                    <el-row style="max-height: 50px" v-show="showInfo(1)">
                                                        <el-col :span="24" style="font-size: 16px"><span class="fg-info">手术：</span>{{ (p.visit.surgeries && p.visit.surgeries) || '--' }}</el-col>
                                                    </el-row>
                                                    <el-row style="max-height: 50px" v-show="showInfo(2)">
                                                        <el-col :span="24" style="font-size: 16px"><span class="fg-info">诊断：</span>{{ (p.visit && p.visit.diseases) || '--' }}</el-col>
                                                    </el-row>
                                                    <el-row style="max-height: 50px" v-show="showInfo(3) || showInfo(4)">
                                                        <el-col :span="12" style="font-size: 16px" v-show="showInfo(3)"
                                                            ><span class="fg-info">病床号：</span>{{ (p.visit && p.visit.bed_no) || '--' }}
                                                        </el-col>
                                                        <el-col :span="12" style="font-size: 16px" v-show="showInfo(4)"
                                                            ><span class="fg-info">房间：</span><span :style="getDynamicStyle((p.visit && p.visit.dic_operating_room) || '--')">{{ (p.visit && p.visit.dic_operating_room) || '--' }}</span></el-col
                                                        >
                                                    </el-row>
                                                    <el-row style="max-height: 50px" v-show="showInfo(11) || showInfo(12)">
                                                        <el-col :span="12" style="font-size: 16px" v-show="showInfo(11)"><span class="fg-info">住院号：</span>{{ (p.visit && p.visit.visit_no) || '--' }}</el-col>
                                                        <el-col :span="12" style="font-size: 16px" v-show="showInfo(12)"><span class="fg-info">科室：</span>{{ (p.visit && p.visit.dic_section) || '--' }}</el-col>
                                                    </el-row>
                                                </div>
                                                <div class="hand padding10 padding-none-h">
                                                    <div class="padding5 padding-none-h" v-show="showInfo(5)">麻醉医师：{{ p.visit.anes_doctor }}</div>
                                                    <div class="padding5 padding-none-h" v-show="showInfo(6)">手术医师：{{ p.visit.surgeon }}</div>
                                                    <div class="padding5 padding-none-h" v-show="showInfo(7)">
                                                        出手术间时间：<span>{{ $moment(p.visit.out_room_time).format('MM/DD HH:mm') }}</span>
                                                    </div>
                                                    <div class="padding5 padding-none-h" v-show="showInfo(8)">
                                                        入室体温：<span :class="{ 'fg-danger': p.visit && p.visit.temperature && p.visit.temperature < 35.5 }">{{
                                                            (p.visit.temperature && `${p.visit.temperature} ℃`) || '--'
                                                        }}</span>
                                                    </div>
                                                    <div class="padding5 padding-none-h" v-show="showInfo(9)">
                                                        入复苏室时间：
                                                        <span class="fg-danger" v-if="checkDatetime(p.visit.in_recovery_room)" title="复苏超过3小时">{{
                                                            $moment(p.visit.in_recovery_room).format('MM/DD HH:mm')
                                                        }}</span>
                                                        <span v-else>{{ $moment(p.visit.in_recovery_room).format('MM/DD HH:mm') }}</span>
                                                    </div>
                                                    <div class="dt padding5 padding-none-h" v-show="showInfo(10)">
                                                        麻醉开始时间：
                                                        <span v-if="p.visit">{{ $moment(p.visit.anesthesia_begin).format('MM/DD HH:mm') }}</span>
                                                        <!-- <text-formatter type="datetime" v-model="p.visit.anesthesia_begin" v-if="p.visit"></text-formatter> -->
                                                    </div>
                                                    <div class="dt padding5 padding-none-h" v-show="showInfo(13)">
                                                        拔管时间：
                                                        <span v-if="p.visit">{{ p.visit.decannulation_date && $moment(p.visit.decannulation_date).format('MM/DD HH:mm') }}</span>
                                                        <!-- <text-formatter type="datetime" v-model="p.visit.anesthesia_begin" v-if="p.visit"></text-formatter> -->
                                                    </div>
                                                </div>
                                            </el-col>
                                            <el-col :span="6" style="border-left: solid 0.5px lightgrey; padding-left: 10px !important">
                                                <div class="line-height20 align-left margin5 margin-none-h" v-for="item in p.monitor_datas" :key="item.physio_param.id">
                                                    <span class="fg-info">{{ item.physio_param.alias || item.physio_param.name }}</span
                                                    ><br />
                                                    <b :class="{ 'fg-danger': item.is_warning }">{{ item.value }}</b> {{ item.physio_param.unit }}
                                                </div>
                                            </el-col>
                                        </el-row>
                                    </el-scrollbar>

                                    <div v-else>
                                        <draggable
                                            tag="div"
                                            class="no-patient"
                                            v-model="list"
                                            v-bind="{ group: { name: 'bed', pull: true, put: ['unrecovries'] }, animation: 150 }"
                                            @change="recoveryBedIn($event, p)"
                                        >
                                            <div class="icon"><font-awesome-icon :icon="['fas', 'bed']"></font-awesome-icon></div>
                                            <!-- <div v-for="l in list" :key="l.id">{{l.patient_name}}</div> -->
                                        </draggable>
                                    </div>
                                </div>
                            </el-card>
                        </el-col>
                    </draggable>
                    <div v-else>
                        <div class="icon" style="line-heigth: 500px; font-size: 300px; opacity: 0.2">
                            <font-awesome-icon :icon="['fas', 'bed']"></font-awesome-icon>
                        </div>
                        <p class="no-surgery">暂无苏醒床位</p>
                    </div>
                </el-scrollbar>
            </el-col>
            <el-col v-show="collapse==0" :span="collapse==0?3:0" class="align-left">
                <div class="recovery-list-header">
                    <span>近24小时复苏({{ recoveries.length }})</span><span class="cus-button is-circle" @click="loadAll" title="刷新"><span class="el-icon-refresh"></span></span>
                </div>
                <el-scrollbar :style="{ height: this.screenHeight - 210 + 'px' }" v-if="recoveries.length > 0">
                    <ul>
                        <li v-for="v in recoveries" :key="v.id" class="line-height20">
                            <el-row>
                                <el-col :span="2" style="line-height: 23px">{{ v.dic_recovery_bed }}</el-col>
                                <el-col :span="10" style="padding-left: 5px;"
                                    ><el-link type="primary" size="mini" @click="loadRevDoc(v.id)">{{ v.patient_name }}</el-link></el-col
                                >
                                <el-col :span="6" style="line-height: 23px;padding-left: 5px;"
                                    >{{ $moment(v.out_recovery_room).format('HH:mm') }}
                                    <span class="circle fg-red borderd" v-if="v.is_reoperation">再</span>
                                </el-col>
                                <el-col :span="6" style="padding-left: 5px;"
                                    ><el-link
                                        v-if="permissions && permissions.findIndex(item => item.permission === 'surgery_list:resuscitation') != -1"
                                        type="primary"
                                        size="mini"
                                        @click="RecoveryBedOutToBedIn(v.id)"
                                        >撤回</el-link
                                    ></el-col
                                >
                            </el-row>
                        </li>
                    </ul>
                </el-scrollbar>
                <p v-else style="color: lightgray">暂无</p>
            </el-col>
        </el-row>

        <cus-dialog :title="inroom.title" :visible.sync="inroom.dialogFormVisible" width="30%" @confirm="setInRoomTemp()">
            <div class="margin10 margin-none-h align-left">
                <span class="align-left line-height30">请填写入室体温（℃）：</span>
                <item-input type="float" v-model="inroom.temperature" style="width: 200px; display: inline-block"></item-input>
            </div>
            <div class="margin10 margin-none-h align-left">
                <span class="align-left line-height30">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;请选择入室时间：</span>
                <item-input type="datetime" v-model="inroom.in_recovery_room_time" style="width: 200px; display: inline-block"></item-input>
            </div>
        </cus-dialog>
        <cus-dialog :title="recoverybed.title" :visible.sync="recoverybed.dialogFormVisible" width="40%" @confirm="changeBeds()">
            <div class="tag-group">
                <div
                    v-for="item in otherrecoveryBeds"
                    :key="item.location_id"
                    class="tag"
                    :class="{ used: item.location_id == oldlocation_id || item.location_id == newlocation_id }"
                    style="margin-top: 10px"
                    @click="checkBed(item)"
                >
                    {{ item.location }}
                </div>
            </div>
        </cus-dialog>
        <cus-dialog :title="scanInRecoveryBed.title" :visible.sync="scanInRecoveryBed.dialogFormVisible" style="font-size: 18px; text-align: left; margin-bottom: 20px; line-height: 30px"  width="40%"
            @confirm="scanInRecoveryBedConfirm()">
            <div style="text-align: left;">
                <span>病人腕带:</span>
                <item-input type="scan" class="margin5 margin-none-h" v-model="searchPatient" placeholder="请扫病历号"
                    :autofocus="true" @input="loadPatient" style="width: 160px; display: inline-block"></item-input>
                <span>床位二维码:</span>
                    <item-input type="scan" class="margin5 margin-none-h" v-model="searchBed" placeholder="请扫床位二维码"
                    @input="loadBed" style="width: 160px; display: inline-block"></item-input>
            </div>
            <div v-if="scanInRecoveryBed.surgeryInfo">
                <div>
                    <span>姓名：<b>{{ scanInRecoveryBed.surgeryInfo.patient_name|| '--' }}</b></span>&nbsp;&nbsp;
                    <span>床号：<b>{{ scanInRecoveryBed.surgeryInfo.bed_no || '--' }}</b></span>&nbsp;&nbsp;
                    <span>性别：<b>{{ scanInRecoveryBed.surgeryInfo.sex || '--' }}</b></span>&nbsp;&nbsp;
                    <span>年龄：<b>{{ scanInRecoveryBed.surgeryInfo.age || '--' }}</b></span>
                    <span>费别：<b>{{ scanInRecoveryBed.surgeryInfo.pay_type || '--' }}</b></span>&nbsp;&nbsp;
                </div>
                <div>
                    <span>台次：<b>{{ scanInRecoveryBed.surgeryInfo.scheduled_sequence || scanInRecoveryBed.surgeryInfo.sequence || '--' }}</b></span>&nbsp;&nbsp;
                    <span>{{ T(`surgery.visit_no`) }}：<b>{{ scanInRecoveryBed.surgeryInfo.visit_no || '--' }}</b></span>&nbsp;&nbsp;
                    <span>门诊号：<b>{{ scanInRecoveryBed.surgeryInfo.his_id || '--' }}</b></span>&nbsp;&nbsp;
                    <span>隔离：<b class="fg-red">{{ scanInRecoveryBed.surgeryInfo.isolation_status || '--' }}</b></span>&nbsp;&nbsp;
                </div>
                <div>
                    <span>{{ T(`surgeryinfo.plan_circuit_nurse`) }}：<b>{{ scanInRecoveryBed.surgeryInfo.circuit_nurse|| '--' }}</b></span>&nbsp;&nbsp;
                    <span>{{ T(`surgeryinfo.plan_equipment_nurse`) }}：<b>{{ scanInRecoveryBed.surgeryInfo.equipment_nurse|| '--' }}</b></span>&nbsp;&nbsp;
                </div>
                <div>
                    科室：<b>{{ scanInRecoveryBed.surgeryInfo.dic_section || '--' }}</b>
                </div>
                <div>
                    {{ T(`surgeryinfo.plan_surgeon`) }}：<b>{{ scanInRecoveryBed.surgeryInfo.surgeon || '--' }}，{{ scanInRecoveryBed.surgeryInfo.surgeon_assistants ||
                        '--' }}</b>
                </div>
                <!-- <div>手术部位：{{scanInRecoveryBed.surgeryInfo.}}</div> -->
                <div>
                    手术名称：<b>{{ scanInRecoveryBed.surgeryInfo.surgeries || '--' }}</b>
                </div>
                <div>
                    手术间：<b>{{ scanInRecoveryBed.surgeryInfo.dic_operating_room || '--' }}</b>
                </div>
                <div>
                    {{ T(`surgeryinfo.plan_anes_doctor`) }}：<b>{{ scanInRecoveryBed.surgeryInfo.anes_doctor || '--' }}</b>
                </div>
                <div>
                    麻醉方法：<b>{{ scanInRecoveryBed.surgeryInfo.anaes_methods || '--' }}</b>
                </div>
                <div>
                    手术部位：<b>{{ scanInRecoveryBed.surgeryInfo.surgical_site || '--' }}</b>
                </div>
                <div style="font-size: 22px;color:red;">
                    安排复苏床位：<b>{{ scanInRecoveryBed.bed.location_id || '--' }}</b>
                </div>
            </div>
        </cus-dialog>
        <cus-dialog :title="settingRoom.title" :visible.sync="settingRoom.dialogFormVisible" width="50%" @confirm="settingRoomSave()">
            <div class="tag-group">
                <el-row><el-col :span="24" class="align-left">复苏室：</el-col></el-row>
                <el-row>
                    <div v-for="item in recoveryWard" :key="item.value" class="tag" :class="{ used: item.value == selectRecoveryWardId }" @click="selectRecoveryWard(item)" style="margin-top: 10px">
                        {{ item.label }}
                    </div>
                </el-row>
            </div>
            <div class="tag-group">
                <el-row><el-col :span="24" class="align-left">复苏床位：</el-col></el-row>
                <el-row>
                    <div v-for="item in tempRecoveryRoom" :key="item.value" class="tag" :class="{ used: item.isCheck }" @click="selectRecoveryRoom(item)" style="margin-top: 10px">
                        {{ item.label }}
                    </div>
                </el-row>
            </div>
        </cus-dialog>
        <cus-dialog :title="message.title" :visible.sync="message.dialogFormVisible" width="30%" @confirm="sendMessageConfirm()">
            <div class="margin10 margin-none-h align-left">
                 <el-input type="textarea"  maxlength="300" :rows="3" v-model="message.remark" placeholder="限制输入300个字符" autocomplete="off"></el-input>
               </div>
        </cus-dialog>
        <cus-dialog :title="waitpanel.title" :visible.sync="waitpanel.dialogFormVisible" width="30%"
            @confirm="sendWaitMessageConfirm()">
            <div class="margin10 margin-none-h align-left">
                <el-input type="textarea" maxlength="300" :rows="3" v-model="waitpanel.remark" placeholder="限制输入300个字符"
                    autocomplete="off"></el-input>
            </div>
        </cus-dialog>
        <el-dialog ref="form_unlock" title="锁定" :close-on-click-modal="true" :visible.sync="alterPasswordDialog.dialogFormVisible" width="30%">
            <el-row>
                <el-input v-model="alterPasswordDialog.data.uid" ref="uid" :clearable="true" :autofocus="true">
                    <template slot="prepend">
                        <i class="el-icon-user"></i>
                    </template>
                </el-input>
            </el-row>
            <el-row>
                <el-input v-model="alterPasswordDialog.data.pwd" ref="pwd" show-password :clearable="true">
                    <template slot="prepend">
                        <i class="el-icon-lock"></i>
                    </template>
                </el-input>
            </el-row>
            <el-row slot="footer" class="dialog-footer" >
                <el-button @click="alterPasswordDialog.dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveLock()">确 定</el-button>
            </el-row>
        </el-dialog>
        <el-dialog title="选择复苏患者" :visible.sync="inRecoveryPatient.dialogFormVisible" class="table-h460" :close-on-click-modal="false" width="90%">
            <crud-facecade
                ref="surgery-list"
                :url="inRecoveryPatient.data"
                :columns="surgeryColunmList"
                :buttons="[]"
                :addButton="{ enabled: false }"
                :updateButton="{ enabled: false }"
                :fuzzySearch="false"
                @rowClick="activTargetRow"
            >
                <template slot="filter">
                    <el-col :span="4">
                        <item-input type="datearraw2" v-model="rdate" :clearable="false" size="mini"></item-input>
                    </el-col>
                    <el-col>
                        <span>病人腕带:</span>
                        <item-input type="scan" class="margin5 margin-none-h" v-model="visitno" placeholder="请扫患者腕带"
                            :autofocus="true" @input="setVisitno" style="width: 160px; display: inline-block"></item-input>
                        <span style="color: red;padding-left: 30px;">*</span><span style="font-weight: bold;">复苏床位：</span>
                        <item-input type="scan" v-model="pRecoverybed" placeholder="请扫床位二维码"
                            @input="getBed" style="width: 160px; display: inline-block"></item-input>
                        <span style="font-size: 22px;color:red;padding-left: 30px;">
                            安排复苏床位：<b>{{ pRecoverybedInfo && pRecoverybedInfo.location || '--' }}</b>
                        </span>
                    </el-col>
                </template>
            </crud-facecade>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelRecord">取 消</el-button>
                <el-button type="primary" @click="Record">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import JSEncrypt from 'jsencrypt/bin/jsencrypt.min'
import draggable from 'vuedraggable'
import Json5 from 'json5'
import { mapGetters } from 'vuex'
export default {
    name: `RecoveryQuery`,
    components: { draggable },
    props: {},
    data() {
        // 监听页面回传消息
        window.addEventListener(`message`, (event) => {
            let d = _.startsWith(event.data, `{`) && Json5.parse(event.data) || {}
            if (d.order == `refreshRevList`) {
                this.loadUnRecoveries()
                this.loadRecoveries()
                this.c = 1
                this.loadRecoveryBeds()
            }
        }, false)
        return {
            title: `复苏记录`,
            collapse: 0,
            needGet: true,
            setRecoveryListRefreshTime: this.$root.SetRecoveryListRefreshTime,
            recoveryTimeConfig: this.$root.RecoveryTimeConfig,
            recoverybedScreenConfig: null,
            recoverybedIds: [],
            oldlocation: null,
            oldlocation_id: null,
            newlocation: null,
            newlocation_id: null,
            defaultRecordBedCount: null,
            patientCards: [],
            recoveryBeds: [],
            otherrecoveryBeds: [],
            recoveryWards: [],
            bigelement: null,
            bigbed: null,
            selectRecoveryWardId: 0,
            selectRecoveryRoomId: 0,
            tempRecoveryRoom: [],
            showscreenbtnPermission: `recovery:recovery_screen_setup`, // 复苏大屏设置按钮
            inRecoveryScanPermission: `recovery:inRecoveryBed_Scan`, // 扫码按钮
            inRecoveryPermission: `recovery:inRecovery`, // 患者直接复苏
            lockBedPermission: `recovery:recovery_bed_lock`, // 显示复苏床卡锁定按钮图标权限
            // dic_recovery_ward_id:undefined,
            unRecoveries: [],
            recoveries: [],
            list: [],
            c: 1,
            permissions: [],
            alterPasswordDialog: {
                title: `解锁`,
                dialogFormVisible: false,
                bed: {},
                data: {
                    uid: ``,
                    pwd: ``,
                    exp: 100000
                },
                columns: [{
                    type: `string`,
                    prop: `uid`,
                    label: `用户名`,
                    readonly: true,
                    colspan: 24
                }, {
                    type: `password`,
                    prop: `pwd`,
                    label: `密码`,
                    // options: [],
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    colspan: 24
                }]
            },
            inroom: {
                dialogFormVisible: false,
                surgeryId: ``,
                temperature: ``,
                in_recovery_room_time: ``,
                title: `入室体温`
            },
            recoverybed: {
                dialogFormVisible: false,
                title: `更换床位`,
                isUsed: true
            },
            settingRoom: {
                dialogFormVisible: false,
                title: `选择复苏室`
            },
            message: {
                dialogFormVisible: false,
                title: `通知内容`,
                messageheaderid: 0,
                remark: `同意申请,请在10分钟内完成入室`
            },
            waitpanel: {
                dialogFormVisible: false,
                title: `等待通知内容`,
                messageheaderid: 0,
                remark: `床位已满,请等待`
            },
            scanInRecoveryBed: {
                dialogFormVisible: false,
                surgeryInfo: {},
                bed: {},
                title: `扫码入复苏床位`
            },
            recoveryBedsInfoConfig: this.$root.RecoveryBedsInfoConfig,
            recoveryApplicationInterval: this.$root.RecoveryApplicationInterval,
            recoveryBedsInfoConfigs: [],
            searchPatient: ``,
            searchBed: ``,
            surgerSubStringRule: this.$root.SurgerSubStringRule,
            surgery_target_row: undefined,
            rdate: this.$moment().format(`YYYY/MM/DD`),
            visitno: ``,
            pRecoverybed: ``,
            pRecoverybedInfo: undefined,
            inRecoveryPatient: {
                dialogFormVisible: false,
                title: `创建患者复苏`,
                data: {
                    baseURL: `/api/Preoperative/Apply/GetSurgeryList`,
                    get: () => {
                        return new Promise((resolve, reject) => {
                            let that = this
                            let req = that.myaxios.get(`/api/Preoperative/Apply/GetSurgeryList?date=${this.rdate}&visitno=${this.visitno}`)
                            req.then(data => {
                                resolve(data)
                            }).catch(e => reject(e))
                        })
                    }
                }
            }
        }
    },
    beforeDestroy() {
        clearInterval(this.interval)
        clearInterval(this.refreshRecoveryList)
    },
    created() {
        let that = this
        this.loadPermissions()
        clearInterval(this.interval)
        clearInterval(this.refreshRecoveryList)
        this.interval = setInterval(() => {
            // needGetMessage用来控制防止卡死，第一次请求返回后才去请求第二次
            if (that.needGet == true) {
                this.loadRecoveryBeds()
            }
        }, 10000)
        if (this.setRecoveryListRefreshTime && this.setRecoveryListRefreshTime > 0) {
            this.refreshRecoveryList = setInterval(() => {
                this.loadUnRecoveries()
                this.loadRecoveries()
            }, this.setRecoveryListRefreshTime * 1000)
        }
        if (this.recoveryBedsInfoConfig) {
            this.recoveryBedsInfoConfigs = this.recoveryBedsInfoConfig.split(`|`).map(d => parseInt(d))
        }
    },
    mounted() {
        this.c = 1
        this.loadRecoveryBeds()
        this.loadDefaultRecordBedCount()
        this.loadUnRecoveries()
        this.loadRecoveries()
    },
    computed: {
        ...mapGetters([`sys_enums`, `recovery_ward_auth`, `recovery_ward_auth_disabled`, `active_ward`, `screenHeight`, `currentUser`]),
        today() {
            return this.$moment().format(`YYYY/MM/DD dddd `)
        },
        isDesktop() {
            return typeof winformMsg != `undefined`
        },
        recoveryWard() {
            {
                let that = this
                let data = _.filter(that.recovery_ward_auth_disabled, (d) => {
                    return d.disabled === false
                })
                return data
            }
        },
        surgeryColunmList() {
            return [
                {
                    type: `string`,
                    label: `序号`,
                    prop: `id`,
                    isListable: false,
                    isKey: true
                },
                {
                    type: `string`,
                    label: this.T(`anesthesia_surgery_list.visit_no`),
                    prop: `visit_no`,
                    isListable: true
                },
                {
                    type: `string`,
                    label: `姓名`,
                    prop: `patient_name`,
                    isListable: true
                },
                {
                    type: `string`,
                    label: `性别`,
                    prop: `sex`,
                    isListable: true
                },
                {
                    type: `string`,
                    label: `年龄`,
                    prop: `age`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `dic_section`,
                    label: `科室`,
                    width: `100`,
                    isListable: true
                },
                {
                    type: `string`,
                    label: `诊断`,
                    prop: `diseases`,
                    isListable: true
                },
                {
                    type: `string`,
                    label: `手术名称`,
                    prop: `surgeries`,
                    isListable: true
                },
                {
                    type: `string`,
                    label: `麻醉方式`,
                    prop: `anaes_methods`,
                    isListable: true
                }
            ]
        }
    },
    methods: {
        triggerCollapse() {
            if (this.collapse == 0) {
                this.collapse = 1
            } else {
                this.collapse = 0
            }
            this.$emit(`triggerCollapse`, this.collapse)
        },
        unRecoveryStyle(info) {
            let style = ``
            if (info.enum_surgery_status == 30) {
                style = `border-top: solid 5px red;`
            } else {
                style = `border-top: solid 1px #dcdfe6;`
            }
            switch (info.enum_message_status) {
            case `1`:
                style += `backgroundColor: #FFFACD;`
                break
            case `2`:
                style += `backgroundColor: Gainsboro;`
                break
            case `3`:
                style += `backgroundColor: aquamarine;`
                break
            default:
                style += `backgroundColor: yellow;`
                break
            }
            return style
        },
        sendMessageToOperRoom(messageheaderid) {
            this.message.dialogFormVisible = true
            this.message.messageheaderid = messageheaderid
        },
        sendMessageConfirm() {
            let req = this.myaxios.get(`/api/Operation/RecoveryApplyMessage/ChangeApplyMessage?bizId=${this.message.messageheaderid}&status=3&content=${this.message.remark || ``}&dic_recoverybed_Id=${this.message.selectedbedid}&is_handle=false&waitMinutes=10`)
            req.then((data) => {
                this.message.dialogFormVisible = false
                this.loadUnRecoveries()
                this.$message.success(`通知发送成功`)
            })
        },
        showWaitToOperRoom(messageheaderid) {
            this.waitpanel.dialogFormVisible = true
            this.waitpanel.messageheaderid = messageheaderid
        },
        sendWaitMessageConfirm() {
            let req = this.myaxios.get(`/api/Operation/RecoveryApplyMessage/ChangeApplyMessage?bizId=${this.waitpanel.messageheaderid}&status=4&content=${this.waitpanel.remark || ``}&is_handle=false`)
            req.then((data) => {
                this.waitpanel.dialogFormVisible = false
                this.loadUnRecoveries()
                this.$message.success(`通知发送成功`)
            })
        },
        loadRecoverybedScreenConfig() {
            // TODO:获取参数配置中默认手术间数量
            let that = this
            let req = this.myaxios.get(`api/AcisSystem/Config/GetByKey?key=RecoverybedScreenConfig`) // 获取参数信息
            req.then(data => {
                if (data) {
                    that.recoverybedScreenConfig = data
                    var array = data.value.split(`,`)
                    that.recoverybedIds = array
                }
            }).catch(e => {})
        },
        // 保存复苏屏设置
        settingRoomSave() {
            var that = this
            var entity = this.recoverybedScreenConfig
            var ids = this.recoverybedIds.toString()
            entity.value = ids
            let req = this.myaxios.put(`/api/AcisSystem/Config/Put`, entity)
            return new Promise((resolve, reject) => {
                req.then(data => {
                    that.$message.success(`保存成功`)
                    that.settingRoom.dialogFormVisible = false
                    resolve(data)
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        selectRecoveryWard(item) {
            this.selectRecoveryWardId = item.value
            this.recoveryRoom()
            this.selectRecoveryRoomId = 0
        },
        recoveryRoom() {
            var that = this
            let wardid = this.selectRecoveryWardId
            let data = _.filter(this.recovery_ward_auth_disabled, (d) => {
                return (d.value == parseInt(wardid))
            })
            // var temp = _.cloneDeep(data[0] && data[0].recovery_bed)
            let rooms = _.filter(data[0] && data[0].recovery_bed, (d) => {
                var id = d.value.toString()
                let result = that.recoverybedIds.some(e => e == id) // true
                if (result) {
                    d.isCheck = true
                } else { d.isCheck = false }
                return d.disabled === false
            }) || []
            this.tempRecoveryRoom = _.orderBy(rooms, `display_order`)
        },
        selectRecoveryRoom(item) {
            if (item.isCheck) {
                var data = this.recoverybedIds.filter(e => e !== item.value.toString())
                this.recoverybedIds = data
            } else {
                var result = this.recoverybedIds.some(e => e == item.value.toString())
                if (!result) { this.recoverybedIds.push(item.value.toString()) }
            }
            item.isCheck = !item.isCheck
        },
        showInRecoveryPatient() {
            this.visitno = ``
            this.inRecoveryPatient.dialogFormVisible = true
        },
        cancelRecord() {
            this.inRecoveryPatient.dialogFormVisible = false
        },
        Record() {
            let surgeryId = this.surgery_target_row && this.surgery_target_row.id
            if (surgeryId === undefined) {
                this.$message.warning(`未选择需要复苏的患者`)
                return
            }
            let benInfo = this.pRecoverybedInfo
            console.log(`benInfo`, benInfo)
            if (!benInfo || !benInfo.location_id) {
                this.$message.warning(`请录入复苏床位`)
                return
            }
            let that = this
            this.$confirm(`确定"${that.surgery_target_row.patient_name},${that.surgery_target_row.visit_no}"患者于"${benInfo.location}"复苏？进入复苏后状态将无法撤销`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            }).then(() => {
                let req = that.myaxios.put(`/api/Postoperative/Recovery/RecoverSurgery?surgeryId=${surgeryId}&bedId=${benInfo.location_id}`)
                req.then(data => {
                    this.c = 1
                    that.loadRecoveryBeds()
                    that.inRecoveryPatient.dialogFormVisible = false
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        activTargetRow({ row }) {
            this.surgery_target_row = row
        },
        showScanInRecoveryBed() {
            this.scanInRecoveryBed.dialogFormVisible = true
        },
        substringcdata(inputval) {
            let outval = ``
            if (this.surgerSubStringRule != ``) {
                let rulestr = this.surgerSubStringRule.split(`,`)
                let left = rulestr[0]
                let right = rulestr[1]
                if (left == 0 && right != 0) {
                    outval = inputval.substring(0, right)
                } else if (left != 0 && right != 0) {
                    outval = inputval.substring(left, right)
                } else {
                    outval = inputval
                }
            } else {
                outval = inputval
            }
            return outval
        },
        setVisitno() {
            this.visitno = this.substringcdata(this.visitno)
        },
        getBed() {
            console.log(6666666)
            let sk = (this.pRecoverybed && this.pRecoverybed) || ``
            if (sk.length > 0) {
                let bed = _.find(
                    this.recoveryBeds,
                    d => {
                        return d.qr_code == sk
                    }
                )
                if (!bed) {
                    this.$message.warning(`暂无该床位`)
                    return
                }
                this.pRecoverybedInfo = bed
            }
        },
        loadPatient() {
            this.searchPatient = this.substringcdata(this.searchPatient)
            let sk = (this.searchPatient && this.searchPatient.toUpperCase()) || ``
            if (sk.length > 0) {
                let surgery = _.find(
                    this.unRecoveries,
                    d => {
                        return (d.visit_no && d.visit_no.toUpperCase() == sk) || (d.his_id && d.his_id.toUpperCase() == sk)
                    }
                )
                if (!surgery) {
                    this.$message.warning(`暂无该患者复苏申请信息`)
                    return
                }
                this.scanInRecoveryBed.surgeryInfo = surgery
            }
        },
        loadBed() {
            let sk = (this.searchBed && this.searchBed) || ``
            if (sk.length > 0) {
                let bed = _.find(
                    this.recoveryBeds,
                    d => {
                        return d.qr_code == sk
                    }
                )
                if (!bed) {
                    this.$message.warning(`暂无该床位`)
                    return
                }
                this.scanInRecoveryBed.bed = bed
            }
        },
        scanInRecoveryBedConfirm() {
            let that = this
            let occurDt = this.$moment().format(`YYYY/MM/DD HH:mm:ss`)
            if (!that.scanInRecoveryBed.surgeryInfo.id) {
                this.$message.error(`未定位到病人,请重新扫病人腕带`)
                return
            }
            if (!that.scanInRecoveryBed.bed.location_id) {
                this.$message.error(`未检索到床位,请重新扫床位二维码`)
                return
            }
            let req = this.myaxios.put(`/api/Postoperative/Recovery/RecoveryBedIn?surgeryInfoId=${that.scanInRecoveryBed.surgeryInfo.id}&bedId=${that.scanInRecoveryBed.bed.location_id}&occurDt=${occurDt}`)
            req.then(data => {
                that.scanInRecoveryBed.surgeryInfo.in_recovery_room = occurDt
                that.$set(that.scanInRecoveryBed.bed, `visit`, that.scanInRecoveryBed.surgeryInfo)
                that.scanInRecoveryBed.dialogFormVisible = false
                that.unRecoveries = _.filter(that.unRecoveries, r => { return r.id != that.scanInRecoveryBed.surgeryInfo.id })
                that.loadRecoveryBeds()
                this.scanInRecoveryBed.surgeryInfo = {}
                this.scanInRecoveryBed.bed = {}
                this.searchBed = ``
                this.searchPatient = ``
            }).catch(e => {
                that.$set(that.scanInRecoveryBed.bed, `visit`, undefined)
            })
        },
        updateScreen() {
            this.loadRecoverybedScreenConfig()
            this.settingRoom.dialogFormVisible = true
        },
        showInfo(num) {
            let that = this
            return (that.recoveryBedsInfoConfigs && _.includes(that.recoveryBedsInfoConfigs, num)) || that.recoveryBedsInfoConfigs.length == 0
        },
        splitName(name) {
            if (this.defaultRecordBedCount == 6 || this.defaultRecordBedCount == 8) {
                // 名字超长处理
                if (name.length > 4) {
                    name = name.substring(0, 4) + `...`
                }
            }
            return name
        },
        loadPermissions() {
            let req = this.myaxios.get(`/api/AcisSystem/Authorization/GetPermissions`) // 获取当前用户的权限
            req.then(data => {
                this.permissions = data
            }).catch(e => {})
        },
        loadDefaultRecordBedCount() {
            let that = this
            let req = this.myaxios.get(`api/AcisSystem/Config/GetByKey?key=DefaultRecordBedCount`) // 获取参数信息
            req.then(data => {
                if (data) {
                    var count = 0
                    if (data.value > 4) {
                        count = 4
                    } else if (data.value <= 0) {
                        count = 1
                    } else {
                        count = parseInt(data.value)
                    }
                    that.defaultRecordBedCount = 24 / count
                } else {
                    that.defaultRecordBedCount = 8
                }
            }).catch(e => {})
        },
        loadRecoveryBeds() {
            let that = this
            if (!this.active_ward || !this.active_ward.recovery_bed) {
                this.recoveryBeds = []
                return
            }
            that.needGet = false
            let req1 = this.c == 1 ? this.myaxios.get(`/api/Postoperative/Recovery/Recoverings`) : []
            let req3 = this.myaxios.get(`/api/AcisSystem/RecoveryBed/Get`)
            let req2 = this.myaxios.post(`/api/Operation/Monitor/MonitorDataV2?recordType=2`, this.recoveryBeds.length > 0 ? _.map(_.filter(this.recoveryBeds, d => d.visit), d => d.location_id) : _.map(this.active_ward.recovery_bed, d => d.value), null, false)
            this.myaxios.all(req1, req2, req3).then(([recoverings, datas, rbeds]) => {
                that.needGet = true
                if (this.c == 1) {
                    let beds = _.map(_.filter(this.active_ward.recovery_bed, d => !d.disabled), d => {
                        let samebed = rbeds.find(j => j.id == d.value)
                        let lock = samebed == null ? false : samebed.is_lock
                        return {
                            location_id: d.value,
                            location: d.label,
                            is_lock: lock,
                            lock_worker_id: samebed && samebed.lock_worker_id,
                            lock_worker_name: samebed && samebed.lock_worker_name || `--`,
                            lock_time: samebed && samebed.lock_time,
                            visit: _.find(recoverings, { dic_recovery_bed_id: d.value }),
                            monitor_datas: [],
                            qr_code: samebed && samebed.qr_code || ``
                        }
                    })
                    this.recoveryBeds = beds
                    this.monitors = beds
                }
                _.forEach(datas, dts => {
                    let index = _.findIndex(this.monitors, m => m.location_id == dts.location_id)
                    let r = { ...this.monitors[index] }
                    r.check_result = dts.check_result
                    r.defaulPhysioparmas = dts.defaulPhysioparmas
                    if (dts.defaulPhysioparmas) {
                        let monitordatas = []
                        _.forEach(dts.defaulPhysioparmas, b => {
                            var physioparma = _.find(dts.monitor_datas, c => b.id == c.id || b.id == c.dic_physio_param_id)
                            if (physioparma) {
                                monitordatas.push(physioparma)
                            } else {
                                monitordatas.push({
                                    physio_param: {
                                        id: b.id,
                                        alias: b.alias,
                                        name: b.name,
                                        unit: b.unit
                                    },
                                    is_warning: false,
                                    value: `--`
                                })
                            }
                        })
                        dts.monitor_datas = monitordatas
                        r.monitor_datas = dts.monitor_datas
                        this.$set(this.monitors, index, r)
                    }
                })
                if (this.c < 6) {
                    ++this.c
                } else {
                    this.c = 1
                }
            })
        },
        loadUnRecoveries() {
            let that = this
            let url = that.recoveryApplicationInterval && that.recoveryApplicationInterval > 0 ? `/api/Operation/RecoveryApplyMessage/GetUnInRoomRecoveryApplyMessage?dic_recovery_ward_id=${that.active_ward && that.active_ward.code == `复苏室` && that.active_ward.origion || 0}` : `/api/Postoperative/Recovery/UnRecoveries`
            let req = that.myaxios.get(url)
            req.then(data => {
                if (that.recoveryApplicationInterval && that.recoveryApplicationInterval > 0 && data != null) {
                    that.unRecoveries = data.map((i, index) => {
                        i.enum_message_status = i.current_key_event
                        i.index = index + 1
                        return i
                    })
                } else {
                    that.unRecoveries = _.filter(data, { dic_recovery_ward_id: that.active_ward && that.active_ward.origion })
                }
                console.log(that.unRecoveries)
            })
        },
        loadRecoveries() {
            let that = this
            let beginTime = this.$moment().add(-1, `days`).format(`YYYY/MM/DD HH:mm:ss`)
            if (this.recoveryTimeConfig) {
                let configs = this.recoveryTimeConfig.split(`|`)
                if (configs.length == 2) {
                    beginTime = this.$moment().add(parseInt(configs[0]), `days`).format(`YYYY/MM/DD`) + ` ${configs[1]}`
                }
            }
            console.log(`beginTime`)
            console.log(beginTime)
            let endTime = this.$moment().format(`YYYY/MM/DD HH:mm:ss`)
            let req = that.myaxios.get(`/api/Postoperative/Recovery/Recovereds`, {
                begin: beginTime,
                end: endTime
            })
            req.then(data => {
                that.recoveries = _.filter(data, { dic_recovery_ward_id: that.active_ward && that.active_ward.origion })
                console.log(that.recoveries)
            })
        },
        loadAll() {
            let that = this
            that.c = 1
            that.loadRecoveryBeds()
            that.loadUnRecoveries()
            that.loadRecoveries()
        },
        async getNewRecoveryApplyMessage(element) {
            let r = await this.myaxios.get(`/api/Operation/RecoveryApplyMessage/Get?id=${element.message_header_id}`)
            return r
        },
        async recoveryBedIn({ added: { element } }, bed) {
            if (this.recoveryApplicationInterval > 0) {
                let data = await this.getNewRecoveryApplyMessage(element)
                if (data) {
                    element.enum_message_status = data.enum_recovery_message_status
                }
                if (element.enum_message_status == 2) {
                    this.$message.error(`复苏申请已撤回,无需安排复苏床位`)
                    return
                }
                if (element.enum_message_status == 1 || element.enum_message_status == 4) {
                    this.$message.error(`安排了复苏申请床位才能入复苏室`)
                    return
                }
                if (element.index != 1) {
                    this.$confirm(`当时患者不是优先患者，是否确认安排该患者复苏？`, `提示`, {
                        confirmButtonText: `确定`,
                        cancelButtonText: `取消`,
                        type: `warning`,
                        closeOnClickModal: false
                    }).then(() => {
                        this.bedIn(element, bed)
                    }).catch((e) => {})
                } else {
                    this.bedIn(element, bed)
                }
            } else {
                this.bedIn(element, bed)
            }
        },
        bedIn(element, bed) {
            // 由原当前时间修改为出手术间时间
            var inRecoveryRoomTime = element.out_room_time
            // ACIS-23564入恢复室时间默认出手术室时间,分钟时间可配置
            if (this.$root.InRecoveryRoomTimeMinutes && !isNaN(this.$root.InRecoveryRoomTimeMinutes)) {
                var min = parseInt(this.$root.InRecoveryRoomTimeMinutes)
                // 设置0的时候，取出室时间，>0则=出室时间+X分组，<0则等于当前时间
                inRecoveryRoomTime = min < 0 ? this.$moment().format(`YYYY/MM/DD HH:mm:ss`) : this.$moment(element.out_room_time).add(min, `minutes`).format(`YYYY/MM/DD HH:mm:ss`)
            }
            this.inroom.in_recovery_room_time = inRecoveryRoomTime // this.$moment().format(`YYYY/MM/DD HH:mm:ss`)

            // 流程改变，点确认后再执行入室操作，jira：ACIS-23578
            if (this.$root.InRoomTemperature == `1`) {
                this.inroom.surgeryId = element.id
                this.inroom.title = `入室体温(${element.patient_name})`
                this.inroom.temperature = ``
                this.inroom.dialogFormVisible = true
                this.bigelement = element
                this.bigbed = bed
            } else {
                let that = this
                let req = this.myaxios.put(`/api/Postoperative/Recovery/RecoveryBedIn?surgeryInfoId=${element.id}&bedId=${bed.location_id}&occurDt=${this.$moment(this.inroom.in_recovery_room_time).format(`YYYY/MM/DD HH:mm:ss`)}`)
                req.then(data => {
                    element.in_recovery_room = this.inroom.in_recovery_room_time
                    this.$set(bed, `visit`, element)
                    that.unRecoveries = _.filter(that.unRecoveries, r => {
                        return r.id != element.id
                    })
                }).catch(e => {
                    this.$set(bed, `visit`, undefined)
                })
            }
        },
        btnchangeBeds(bed) {
            this.recoverybed.dialogFormVisible = true
            this.oldlocation = bed.location
            this.oldlocation_id = bed.location_id
            let otherBeds = this.recoveryBeds
            this.otherrecoveryBeds = otherBeds.filter(item => item.location_id != bed.location_id)
        },
        changeBeds() {
            let that = this
            if (this.oldlocation_id == this.newlocation_id || this.newlocation_id == null) {
                this.recoverybed.dialogFormVisible = false
                return
            }
            that.$confirm(`确认将 ${this.oldlocation} 与 ${this.newlocation} 手术进行交换?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            }).then(() => {
                let req = that.myaxios.put(`/api/Postoperative/Recovery/Exchange?bedIdA=${this.oldlocation_id}&bedIdB=${this.newlocation_id}`)
                req.then(data => {
                    this.c = 1
                    this.loadRecoveryBeds()
                    that.$message.success(`交换成功`)
                    this.recoverybed.dialogFormVisible = false
                }).catch(e => {
                    this.c = 1
                    this.loadRecoveryBeds()
                    that.$message.error(`交换失败`)
                })
            }).catch((e) => {
                this.c = 1
                this.loadRecoveryBeds()
            })
        },
        checkBed(newbed) {
            this.newlocation = newbed.location
            this.newlocation_id = newbed.location_id
        },
        recoveryBedReply(bed) {
            let that = this
            that.$confirm(`确定退回到未复苏?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            }).then(() => {
                let req = this.myaxios.put(`/api/Postoperative/Recovery/RecoveryBedReplay?surgeryInfoId=${bed.visit.id}`)
                req.then(data => {
                    this.c = 1
                    that.loadUnRecoveries()
                    that.loadRecoveryBeds()
                    that.loadRecoveries()
                }).catch(e => {})
            })
        },
        RecoveryBedOutToBedIn(id) {
            let that = this
            console.log(id)
            that.$confirm(`确定撤回到苏醒中?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            }).then(() => {
                let req = this.myaxios.put(`/api/Postoperative/Recovery/RecoveryBedOutToBedIn?surgeryInfoId=${id}`)
                req.then(data => {
                    this.c = 1
                    that.loadUnRecoveries()
                    that.loadRecoveryBeds()
                    that.loadRecoveries()
                }).catch(e => {})
            })
        },
        recoveryBedOut(bed) {
            let that = this
            that.$confirm(`确认出苏醒室?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            }).then(() => {
                let req = this.myaxios.put(`/api/Postoperative/Recovery/RecoveryBedOut?surgeryInfoId=${bed.visit.id}&occurDt=${this.$moment().format(`YYYY/MM/DD HH:mm:ss`)}`)
                req.then(data => {
                    that.$set(bed, `visit`, undefined)
                    this.c = 1
                    that.loadRecoveryBeds()
                    that.loadRecoveries()
                }).catch(e => {
                    that.$message.error(`出苏醒室失败！`)
                })
            })
        },
        exchangeBed($event) {
            let that = this
            let {
                moved: { newIndex, oldIndex }
            } = $event
            if (oldIndex == newIndex) {
                this.c = 1
                this.loadRecoveryBeds()
                return
            }
            let oldEle = that.recoveryBeds[newIndex + (newIndex < oldIndex ? 1 : -1)]
            let newEle = that.recoveryBeds[newIndex]
            that.$confirm(`确认将 ${oldEle.location} 与 ${newEle.location} 手术进行交换?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            }).then(() => {
                let req = that.myaxios.put(`/api/Postoperative/Recovery/Exchange?bedIdA=${oldEle.location_id}&bedIdB=${newEle.location_id}`)
                req.then(data => {
                    this.c = 1
                    this.loadRecoveryBeds()
                    that.$message.success(`交换成功`)
                }).catch(e => {
                    this.c = 1
                    this.loadRecoveryBeds()
                    that.$message.error(`交换失败`)
                })
            }).catch((e) => {
                this.c = 1
                this.loadRecoveryBeds()
            })
        },
        saveLock() {
            let that = this
            let user = Object.assign({}, this.alterPasswordDialog.data)
            if (this.$root.PwdEncryptEnabled && this.$root.PwdEncryptEnabled == `1` && this.$root.RsaPublicKeyLogin) {
                let encryptor = new JSEncrypt()
                encryptor.setPublicKey(this.$root.RsaPublicKeyLogin)
                user.pwd = encryptor.encrypt(user.pwd)
            }

            this.myaxios
                .post(`api/AcisSystem/Authorization/Login`, {
                    user_agent: `chrome`,
                    timestamp: new Date().getTime(),
                    data: user
                })
                .then(data => {
                    console.log(`data`, data)
                    console.log(`user`, user)
                    that.saveLockBed(that.alterPasswordDialog.bed, user.uid)
                })
        },
        lockBed(bed) {
            let that = this
            that.$confirm(`确认${bed.is_lock ? `解除锁定` : `锁定`}床位?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            }).then(() => {
                if (bed.is_lock) {
                    console.log(bed.lock_worker_id, this.currentUser)
                    if (bed.lock_worker_id && this.currentUser.dic_worker_id == bed.lock_worker_id) {
                        this.saveLockBed(bed)
                    } else {
                        this.$message.error(`仅锁定人可解锁`)
                    }
                } else {
                    this.alterPasswordDialog.data.uid = this.currentUser.username
                    this.alterPasswordDialog.dialogFormVisible = true
                    this.alterPasswordDialog.bed = bed
                }
            }).catch((e) => {
            })
        },
        saveLockBed(bed, username) {
            let that = this
            let req = that.myaxios.put(`/api/AcisSystem/RecoveryBed/LockBed?bedId=${bed.location_id}&username=${username}`)
            req.then((data) => {
                let req1 = this.myaxios.get(`/api/AcisSystem/RecoveryBed/Get`)
                req1.then((beds) => {
                    this.recoveryBeds = this.recoveryBeds.map(i => {
                        let samebed = beds.find(j => j.id == i.location_id)
                        i.is_lock = samebed == null ? false : samebed.is_lock
                        i.lock_worker_id = samebed && samebed.lock_worker_id
                        i.lock_worker_name = samebed && samebed.lock_worker_name || `--`
                        i.lock_time = samebed && samebed.lock_time
                        return i
                    })
                    that.alterPasswordDialog.dialogFormVisible = false
                    that.alterPasswordDialog.bed = {}
                    that.alterPasswordDialog.data = {
                        uid: ``,
                        pwd: ``,
                        exp: 100000
                    }
                }).catch(e => console.log(e))
                that.$message.success(`操作成功`)
            }).catch(e => console.log(e))
        },
        loadRevDoc(surgeryid) {
            let r = typeof winformMsg
            if (r != `undefined`) {
                var cefJson = {
                    action: `openRev`,
                    id: surgeryid
                }
                winformMsg.acceptMessage(cefJson)
            } else {
                this.$message.warning(`网页模式无法进入复苏单编辑界面`)
            }
        },
        checkDatetime(dat) {
            if (dat) {
                return this.$moment(dat).add(3, `hours`).isBefore(this.$moment())
            }
            return false
        },
        setInRoomTemp() {
            if (this.inroom.temperature > 43 || this.inroom.temperature < 32) {
                this.$message.warning(`体温范围为32℃-43℃`)
                return
            }
            let req = this.myaxios.put(`/api/Postoperative/Recovery/SetInRoomTempNew/${this.inroom.surgeryId}?temperature=${this.inroom.temperature}&in_recovery_room_time=${this.$moment(this.inroom.in_recovery_room_time).format(`YYYY/MM/DD HH:mm:ss`)}`)
            req.then(() => {
                this.c = 1
                let that = this
                let req = this.myaxios.put(`/api/Postoperative/Recovery/RecoveryBedIn?surgeryInfoId=${this.bigelement.id}&bedId=${this.bigbed.location_id}&occurDt=${this.$moment(this.inroom.in_recovery_room_time).format(`YYYY/MM/DD HH:mm:ss`)}`)
                req.then(data => {
                    this.bigelement.in_recovery_room = this.inroom.in_recovery_room_time
                    this.$set(this.bigbed, `visit`, this.bigelement)
                    that.unRecoveries = _.filter(that.unRecoveries, r => { return r.id != this.bigelement.id })
                    this.loadRecoveryBeds()
                    this.inroom.dialogFormVisible = false
                }).catch(e => {
                    this.$set(this.bigbed, `visit`, undefined)
                })
            })
        },
        getDynamicStyle(content) {
            let contentLength = this.getCountLength(content)
            return {
                color: `red`,
                fontSize: contentLength > 4 ? `16px` : `24px`
            }
        },
        getCountLength(str) {
            if (!str) return 0
            let len = 0
            for (let i = 0; i < str.length; i++) {
                let charCode = str.charCodeAt(i)
                // 判断是否为汉字（汉字的 Unicode 范围大致在 0x4E00 到 0x9FA5 之间）
                if ((charCode >= 0x4E00 && charCode <= 0x9FA5) || charCode > 255) {
                    len += 2 // 汉字算 2 个长度单位
                } else {
                    len += 1 // 字母、数字、符号等算 1 个长度单位
                }
            }
            return len
        }
    },
    watch: {
        active_ward: function() {
            this.c = 1
            this.loadRecoveryBeds()
            this.loadUnRecoveries()
            this.loadRecoveries()
        },
        rdate: function(newVal, oldVal) {
            this.$refs[`surgery-list`].ReloadListData()
        },
        visitno: function(newVal, oldVal) {
            this.$refs[`surgery-list`].ReloadListData()
        },
        'scanInRecoveryBed.dialogFormVisible': function(newval, oldval) {
            if (newval == false) {
                this.scanInRecoveryBed.surgeryInfo = {}
                this.scanInRecoveryBed.bed = {}
                this.searchBed = ``
                this.searchPatient = ``
            }
        }
    }
}
</script>
<style  lang="less" scoped>
.card-header {
    text-align: left;
    font-size: 18px;
    font-family: Arial;
    /*background: darkkhaki;*/
}
.card-content {
    // padding: 14px;
    height: 340px;
    text-align: left;
    background: #f5f6f7;
    .hand {
        font-size: 14px;
    }
    .dt {
        color: darkgoldenrod;
    }
    .el-row {
        padding: 2px !important;
    }
    //  .el-col {
    //   padding: 0 !important;
    //   font-size:12px;
    // }
    .no-patient {
        text-align: center;
        color: grey;
        opacity: 0.5;
        height: 220px;
        .icon {
            font-size: 100px;
            line-height: 240px;
        }
    }
}
ul {
    list-style: none;
    padding: 0;
    margin: 0;
    border: solid 1px #dcdfe6;
    border-top: unset;
    li {
        border-top: solid 1px #dcdfe6;
        padding: 5px;
        font-size: 12px;
        cursor: move;
    }
}
.surgery-status-tag {
    width: 12px;
    float: left;
    height: 100px;
}
.recovery-list-header {
    margin-top: 5px;
    background: var(--primary-color, #009688);
    color: white;
    line-height: 35px;
    text-align: center;
    border-bottom: solid 0.5px lightgray;
}
.chosenClass {
    background: lightgrey;
}
h1 {
    text-align: left;
    padding: 0;
    font-size: 30px;
    margin: 0;
}

//复苏床位
.tag {
    min-width: 100px;
    height: 50px;
    line-height: 50px;
    border-radius: 10px;
    float: left;
    margin-left: 20px;
    background: #cccccc;
    color: #000;
}
.usedtag{
    background: #ea8b1e;
}
.used {
    background: var(--primary-color, #009688);
    color: #fff;
}
</style>
<style>
.theme-dark .el-dialog__body,
.theme-his-blue .el-dialog__body {
    padding: 0 20px 0 20px !important;
    overflow: auto;
    background: #fafafa;
}
</style>



// WEBPACK FOOTER //
// src/components/Recovery/Record.vue